import rcRelatedArticles from './rc-related-articles';

export const RELATED_ARTICLES = {
  entityName: 'mortgages_refinance_related_articles',
  sectionName: 'mortgages_refinance_related_articles',
  sectionPosition: 6,
  articles: rcRelatedArticles,
};
